<template>
  <footer>
        <div class="container">
            <div class="row">
                <div class="footer_in col-xs-12">
                    <div  class="footer_left col-lg-3 col-md-3 col-sm-3 col-xs-4">
                        <a title="Drishti" href="#"><img src="../assets/images/dristi1.png" alt="logo" class="img-responsive"></a>
                          
                      </div>
                      <div class="footer_right col-lg-6 col-md-6 col-sm-6 col-xs-4">
                        <div class="footer_social">
                          <h6>Follow us</h6>
                              <ul>
                                  <!-- <li><a target="blank" href="https://www.facebook.com/drishtikathmandu/?ref=br_rs"><img src="../assets/images/social_1.png" alt="social" width="35" height="34"></a></li> -->
                                  <li><a target="blank" href="https://www.facebook.com/drishtikathmandu/?ref=br_rs"><img src="../assets/images/social_2.png" alt="social" width="35" height="34"></a></li>
                              </ul>
                          </div>
                      </div>
                      <div  class="footer_left col-lg-3 col-md-3 col-sm-3 col-xs-4">
                        <ul>
                            <li><a href="mailto:drishti.kathmandu@gmail.com">contact us</a></li>

                          </ul>
                      </div>
                      <div class="clear"></div>
                  </div>
              </div>
          </div>
          <div class="copy col-xs-12">
            <div class="container">
                <div class="row">

                      <p>Copyright 2017 Drishti Kathmandu - All Rights Reserved</p>
                      <div class="clear"></div>
                  </div>
              </div>
          </div>
      </footer>

</template>

  <script>
  export default {
    name: 'footerview',
    data () {
      return {
      }
    }
  }
  </script>



// WEBPACK FOOTER //
// FooterView.vue?210dd88d